import React, { Component } from "react";
import SearchBox from "../../components/Search/SearchBox";
import KeySearch from "../../components/Search/KeySearch";
import MajorBox from "../Major/components/MajorBox";
import MajorFilter from "../Major/components/MajorFilter";
import Loading from "../../components/Loading";
import { post, get } from "../../utils/request";
import "./style.css";
import "../../index.css";
var finished = true;
class Major extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      filterVisible: false,
      searchVisible: true,
      dataListVisible: true,
      filterData: null,
      params: {
        majorCategoryId: null,
        majorName: null,
        majorTypeId: null,
        pageNum: 1,
        pageSize: 5,
      },
    };
    this.removeListener = false;
  }
  render() {
    const { data, dataList, filterVisible, filterData } = this.state;
    return (
      <div ref={this.myRef}>
        <SearchBox
          handleCloseDataList={this.handleCloseDataList}
          handleVisibleFilter={this.handleVisibleFilter}
          placeholder="请输入要查询的专业"
          visible={this.state.searchVisible}
          handleVisibleSearch={this.handleVisibleSearch}
        ></SearchBox>
        <KeySearch
          visible={!this.state.searchVisible}
          requestFilterMajorList={this.requestFilterMajorList.bind(this)}
          handleChangeParams={this.handleChangeParams.bind(this)}
          handleVisibleSearch={this.handleVisibleSearch}
          handleAddScroll={this.handleAddScroll}
          handleShowDataList={this.handleShowDataList}
          placeholder="请输入要查询的专业"
        ></KeySearch>
        {filterData != null ? (
          <MajorFilter
            handleAddScroll={this.handleAddScroll}
            handleVisibleFilter={this.handleVisibleFilter}
            requestMajorFilter={this.requestMajorFilter.bind(this)}
            requestFilterMajorList={this.requestFilterMajorList.bind(this)}
            handleChangeParams={this.handleChangeParams.bind(this)}
            filterData={filterData}
            visible={filterVisible}
          ></MajorFilter>
        ) : (
          ""
        )}
        <div style={{ height: 44 }}></div>
        {data != null ? (
          <div className={this.state.dataListVisible ? "" : "display_none"}>
            {dataList.map((item, index) => {
              return <MajorBox key={index} item={item}></MajorBox>;
            })}
            {this.state.params.pageNum < data.data.pages ? (
              <Loading></Loading>
            ) : (
              <div className="majorList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="majorList_shim"></div>
      </div>
    );
  }
  componentWillMount() {
    this.requestShareConfig();
  }
  componentDidMount() {
    this.requestMajorList();
    this.requestMajorFilter(1);
    this.handleAddScroll();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.title = "浙考之家-专业大全";
  }
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-专业大全", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-专业大全", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };

  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.params.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
  }
  /**
   * 控制搜索框显示和关闭
   */
  handleVisibleSearch = () => {
    this.setState({
      ...this.state,
      searchVisible: !this.state.searchVisible,
    });
  };
  /**
   *控制侧边栏条件过滤框的关闭和展示
   */
  handleVisibleFilter = () => {
    if (this.state.filterVisible === true) {
      this.setState({
        filterVisible: false,
      });
    } else {
      this.setState({
        filterVisible: true,
      });
    }
  };
  /**
   * 显示列表
   */
  handleShowDataList = () => {
    this.setState({
      dataListVisible: true,
    });
  };
  /**
   * 隐藏列表
   */
  handleCloseDataList = () => {
    this.setState({
      dataListVisible: false,
    });
  };
  /**
   * 修改请求参数
   */
  handleChangeParams(params) {
    this.setState({
      ...this.state,
      params: {
        majorCategoryId: params.majorCategoryId,
        majorName: params.majorName,
        majorTypeId: params.majorTypeId,
        pageNum: 1,
        pageSize: 5,
      },
    });
  }

  /**
   * 有过滤条件时使用的
   */
  requestFilterMajorList() {
    post("/public/v1/major/list", this.state.params).then((data) => {
      const newDataList = data.data.list;
      this.setState({
        data: data,
        dataList: newDataList,
      });
      finished = true;
    });
  }
  /**
   * 请求专业列表
   */
  requestMajorList() {
    post("/public/v1/major/list", this.state.params).then((data) => {
      const newDataList = this.state.dataList.concat(data.data.list);
      this.setState({
        data: data,
        dataList: newDataList,
      });
      finished = true;
    });
  }
  /**
   * 请求过滤的条件
   */
  requestMajorFilter(id) {
    get("/public/v1/major/filter/" + id).then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const majorListTop = this.myRef.current.offsetTop;
    const majorListHeight = this.myRef.current.offsetHeight;
    if (
      finished &&
      scrollTop >= majorListHeight + majorListTop - screenHeight - 2
    ) {
      finished = false;
      setTimeout(() => {
        this.setState({
          params: {
            ...this.state.params,
            pageNum: this.state.params.pageNum + 1,
          },
        });
        this.requestMajorList();
      }, 500);
    }
  };
}

export default Major;



// WEBPACK FOOTER //
// ./src/containers/Major/index.js